import cookie from 'cookie'
import JsCookie from 'js-cookie'

function setContentType(res, headers) {
  res.set('Content-Disposition', headers['content-disposition'])
  res.set('Content-Type', headers['content-type'])
}

function getCookies(req, store) {
  const cookies = {}
  let reqCookies
  if (process.server) {
    reqCookies = req.headers.cookie || ''
    store.commit('SET_REQ_COOKIES', reqCookies)
  } else {
    reqCookies = store.state.reqCookies || ''
  }

  const cookieObj = cookie.parse(reqCookies)

  cookies.get = (cookieKey) => cookieObj[cookieKey]
  cookies.getAll = () => cookieObj

  return cookies
}

function getCleanedJobTitle(title) {
  if (!title) {
    return ''
  }

  let replaceToDashes = title
    .trim()
    .replace(/\s+/g, '-')
    .replace(/\//g, '-')
    .replace(/-+/g, '-')
    .toLowerCase()
  replaceToDashes = encodeURIComponent(replaceToDashes)
  return replaceToDashes
}

function currencySign(currency, verb) {
  switch (currency) {
    case 'EUR':
      return `€${verb}`
    case 'USD':
      return `$${verb}`
    case 'CHF':
      return `CHF${verb}`
    case 'GBP':
      return `£${verb}`
    case 'CNY':
      return `¥${verb}`
    case 'CAD':
      return `$${verb}`
    case 'INR':
      return `₹${verb}`
    case 'HKD':
      return `HK$${verb}`
    case 'SGD':
      return `S$${verb}`
    case 'SEK':
      return `kr${verb}`   
    case 'MXN':
      return `$${verb}`   
    case 'CRC':
      return `₡${verb}`   
    case 'BRL':
      return `R$${verb}`   
    case 'AUD':
      return `$${verb}`   
    case 'JPY':
      return `¥${verb}`   
    case 'MYR':
      return `RM${verb}`   
    case 'NZD':
      return `$${verb}`   
    case 'MYR':
      return `RM${verb}`   
    default:
      return `€${verb}`
  }
}

function removeAuthCookies() {
  JsCookie.remove('auth._token.local')
  JsCookie.remove('auth._refresh_token.local')
  JsCookie.remove('auth._token_expiration.local')
  JsCookie.remove('auth._refresh_token_expiration.local')
}

export { setContentType, getCookies, getCleanedJobTitle, currencySign, removeAuthCookies }
